import type { PrimaryType } from '@fiverr-private/homepage_common_types';
import type { IPrimaryBasicData, PrimarySDKComponent, PrimarySDKFunctions } from '@fiverr-private/primary_section_sdk';
import { PrimaryDefaultSDKComponentImpl, PrimaryDefaultSDKFunctionsImpl } from './defaultPrimary';

type PrimarySDK<T extends IPrimaryBasicData> = PrimarySDKFunctions & PrimarySDKComponent<T>;

export const PrimaryMapper: Record<Extract<PrimaryType, 'default'>, PrimarySDK<any>> = {
    default: {
        ...PrimaryDefaultSDKComponentImpl,
        ...PrimaryDefaultSDKFunctionsImpl,
    },
    // marketing: {
    //     ...PrimaryMarketingSDKComponentImpl,
    //     ...PrimaryMarketingSDKFunctionsImpl,
    // },
    // orders: {
    //     ...PrimaryOrdersSDKComponentImpl,
    //     ...PrimaryOrdersSDKFunctionsImpl,
    // },
    // agencies: {
    //     ...PrimaryAgenciesSDKComponentImpl,
    //     ...PrimaryAgenciesSDKFunctionsImpl,
    // },
    // dynamic_matching: {
    //     ...PrimaryDynamicMatchingSDKComponentImpl,
    //     ...PrimaryDynamicMatchingSDKFunctionsImpl,
    // },
    // project_management: {
    //     ...PrimaryProjectManagementSDKComponentImpl,
    //     ...PrimaryProjectManagementSDKFunctionsImpl,
    // },
};
